module.exports = __webpack_public_path__ + "static/media/Default_Game_Web_Tile@3x.6c1d738c.png";